import { createFileRoute } from '@tanstack/react-router'
import { SignInPage } from '@pa/staff'
import { z } from 'zod'
import { IMPERSONATION_SIGN_IN_HINT, readImpersonation } from '@/features/impersonation'

const search = z.object({
  redirect: z.string().optional().catch(undefined),
  reason: z.string().optional().catch(undefined),
})

/** A-01 (Frontend §5.2), with the impersonation hand-off hint (Frontend §6.4; T-A01-11). */
export const Route = createFileRoute('/sign-in')({
  validateSearch: search,
  component: function SignInRoute() {
    const { redirect, reason } = Route.useSearch()
    const hint = readImpersonation() ? IMPERSONATION_SIGN_IN_HINT : undefined
    return <SignInPage siteName="PF Appointments" redirect={redirect} reason={reason} hint={hint} />
  },
})
